module.exports = __webpack_public_path__ + "files/490ec599faf6a8ce39259b48b026d99f.svg";